/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericApiService } from '@pm-ui/core-services';
import { Observable } from 'rxjs';
import { UsersEndpoints } from '../config';
import { IUserVM } from '../models';

interface User {
  userId: number;
  name: string;
  emailId: string;
  fullName?: string;
  isActive: boolean;
  canManageBlogs?: boolean; // Add this if it exists in API
  selected?: boolean; // This is for UI only
}

interface SendBlogRequest {
  blogId: number;
  userIds?: number[];
}

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private genericApiService: GenericApiService, private http: HttpClient) {}

  private apiUrl = 'http://localhost:22076/api/Users';


getAllUsers(): Observable<HttpResponse<User[]>> {
  return this.genericApiService.get<User[]>(UsersEndpoints.GetUser);
}


  getUserById<T>(id: number): Observable<HttpResponse<T>> {

    return this.genericApiService.get<T>(`${UsersEndpoints.getUserById}/${id}`);
  }

  getAllUsersInfos<T>(reqModel: any): Observable<any> {
    return this.genericApiService.post(UsersEndpoints.GetUsers, reqModel);
  }
  addUpdateUser<T>(reqModel: any): Observable<unknown> {
    return this.genericApiService.post(UsersEndpoints.AddUpdateUser, reqModel);
  }




  updatePassword<T>(reqModel: any): Observable<unknown> {
    return this.genericApiService.post(UsersEndpoints.UpdatePassword, reqModel);
  }
  getAuthorityDropDown<T>(): Observable<HttpResponse<T>> {
    return this.genericApiService.get<T>(UsersEndpoints.AuthorityDropDown);
  }

  deleteUserDetails<T>(userId: number): Observable<HttpResponse<T>> {
    return this.genericApiService.delete(
      `${UsersEndpoints.DeleteUser}/${userId}`
    );
  }

  checkActiveUsers<T>(userId: number): Observable<HttpResponse<T>> {
    return this.genericApiService.delete(
      `${UsersEndpoints.CheckInactiveUser}/${userId}`
    );
  }
  getSitesDropDown<T>(): Observable<HttpResponse<T>> {
    return this.genericApiService.get<T>(UsersEndpoints.SitesDropDown);
  }

  getUserBySiteIdDropDown<T>(reqModel: any): Observable<HttpResponse<T>> {
    return this.genericApiService.post(
      UsersEndpoints.GetAllUserUsingSiteId,
      reqModel
    );
  }

  addUpdateWorkOrderTemplates<T>(reqModel: any): Observable<unknown> {
    return this.genericApiService.post(
      UsersEndpoints.AddUpdateWorkOrderTemplates,
      reqModel
    );
  }

  getAllWorkOrderTemplates<T>(reqModel: any): Observable<any> {
    return this.genericApiService.post(
      UsersEndpoints.GetWorkOrderTemplates,
      reqModel
    );
  }

  DeleteWorkOrderTemplates<T>(userId: number): Observable<HttpResponse<T>> {
    return this.genericApiService.delete(
      `${UsersEndpoints.DeleteWorkOrderTemplates}/${userId}`
    );
  }
  GetAllUserNameForTechinician<T>(): Observable<HttpResponse<T>> {
    return this.genericApiService.get(
      `${UsersEndpoints.GetAllUserNameForTechinician}`
    );
  }
  sendMailReply<T>(reqModel: any): Observable<any> {
    return this.genericApiService.post(
      `${UsersEndpoints.sendMailReply}`,
      reqModel
    );
  }

  getAllUserInfoToExport<T>(reqModel: any): Observable<any> {
    return this.genericApiService.post(
      UsersEndpoints.GetAllUserInfoToExport,
      reqModel
    );
  }

  getAllTechnicianInfoToExport<T>(siteId: number): Observable<any> {
    return this.genericApiService.post(
      `${UsersEndpoints.GetAllTechnicianInfoToExport}?siteId=${siteId}`,
      {}
    );
  }

 
  

  getUserSiteAuthorities<T>(userId: number): Observable<HttpResponse<T>> {
  return this.genericApiService.get<T>(`${UsersEndpoints.GetUserSiteAuthorities}/${userId}`);
}


  
}
